import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import Spanish from '../lang/sp.json';
import English from '../lang/en.json';

export const Context = React.createContext();

let currentLocale = localStorage.getItem('locale');
let lang;

function setup() {
    if (currentLocale === 'es') {
        lang = Spanish;
    } else {
        lang = English;
    }
}

if (currentLocale) {
    setup();
}
else {
    localStorage.setItem('locale', 'en');
    setup();
}



const Wrapper = (props) => {
    const [locale, setLocale] = useState(currentLocale);

    const [messages, setMessages] = useState(lang);

    function selectLanguage(val) {
        const newLocale = val.value;
        setLocale(newLocale);
        localStorage.setItem('locale', newLocale);
        if (newLocale === 'en') {
            setMessages(English);
        } else if (newLocale === 'es') {
            setMessages(Spanish);
        }
    }

    return (
        <Context.Provider value={{ locale, selectLanguage }}>
            <IntlProvider messages={messages} locale={locale}>
                {props.children}
            </IntlProvider>
        </Context.Provider>

    );
}


export default Wrapper;